export default __webpack_public_path__ + "static/media/medical-records-large.16dde815.png";